import React, { Component } from 'react';
import * as d3 from 'd3';

import VillagerAvatar from '../components/VillagerAvatar';
import Button from '../components/Button';
import Dialogue from '../components/Dialogue';

import ChartSpecs from '../data/chart_specs';

const colorWheelObj = ChartSpecs.chartspecs.colorWheelObjGoodlooking
var colorWheelArray = Object.keys(colorWheelObj);
var colorRange = Object.values(colorWheelObj);
var margin = ChartSpecs.chartspecs.margin;

const scoreObj = {
  "Very Good Looking":1,
  "Good Looking": 2,
  "Average Looking": 3,
  "Slightly Strange Looking":4,
  "Very Strange Looking":5,
}

//use reaction for icons

class VillagerAppearanceGoodlooking extends Component {
  constructor(props){
      super(props);
      this.state = {
        chartType: "viewbyPercentage"
      }
      this.svgRef = React.createRef();

      this.allVillagers = this.props.villagers;
      this.tierNodes = {};

      this.scoreLabel = this.scoreLabel.bind(this);
      this.changeChart = this.changeChart.bind(this);
      this.removeChart = this.removeChart.bind(this);
   }

   componentDidMount() {
     this.svg = d3.select(this.svgRef.current);

     this.tierNodes = d3.groups(this.allVillagers, d => d.tier, d => this.scoreLabel(d.Apperance_Score));
     this.tierNodes2 = d3.rollup(this.allVillagers, v => v.length, d => d.tier, d => this.scoreLabel(d.Apperance_Score));
     this.tierArray = [...this.tierNodes2.keys()];

     this.drawStackBarChart();

   }


   scoreLabel(score){
       if(score === 5){
         return 'Very Good Looking'
       }else if(score === 4){
         return 'Good Looking'
       }else if(score === 3){
         return 'Average Looking'
       }else if(score === 2){
         return 'Slightly Strange Looking'
       }else if(score === 1){
         return 'Very Strange Looking'
       }
   }

   drawStackBarChart(){
     var svg = this.svg,
         chartWidth = this.svgRef.current.clientWidth,
         chartHeight = 430,
         stackKeys = colorWheelArray,
         tooltip = d3.select('#tooltip-goodlooking'),
         radius = 40,
         skinColors =  this.props.villagerSkinColors,
         textColors =  this.props.villagerTextColors;

    // let allVillagers = this.allVillagers;

     let tierNodes = this.tierNodes,
          tierNodes2 = this.tierNodes2,
          tierArray = this.tierArray;

     let tableData = Array.from(tierNodes2.entries())
     .map(g => {
       const obj = {};
       obj["tier"] = g[0];
       for (let col of stackKeys) {
         const vals = g[1].get(col);
         //console.log("vals: "+vals);
         obj[col] = !vals ? 0 : vals;
       }
       return obj;
     })
    .sort((a, b) => a["tier"] - b["tier"]);




     chartHeight = tierNodes.length * radius + margin.top + margin.bottom

     const yScale = d3.scaleBand()
           //.domain(tierNodes.map(d => d[0])) //tiers
           .domain(tierArray)
           .range([margin.top, chartHeight - margin.bottom])
           .padding(0.25)

     const xScale= d3.scaleLinear()
                   .range([margin.left, chartWidth - margin.right])


     const colorScale = d3.scaleOrdinal()
                 .domain(colorWheelArray)
                 .range(colorRange)

     const xAxis = g => g
                 .attr("transform", `translate(0,${margin.top+10})`)
                 .call(d3.axisTop(xScale).ticks(chartWidth / 100, "%"))
                 .call(g => g.selectAll(".domain").remove());

     const yAxis = g => g
               .attr("transform", `translate(${margin.left},0)`)
               .call(d3.axisLeft(yScale).tickFormat(function(d,i){ return `T.${d}` }).tickSizeOuter(0))
               .call(g => g.selectAll(".domain").remove())



     const formatPercent = d3.format(".1%");
     const formatValue = x => isNaN(x) ? "N/A" : x.toLocaleString("en")
     /* set up mutiple colli  */
     let basePerRow = 10,
         baseRowWidth = (chartWidth + 0) / (basePerRow + 1);

     const series = d3.stack()
                   .keys(stackKeys)
                   .offset(d3.stackOffsetExpand)
                 (tableData)
                   .map(d => (d.forEach(v => v.key = d.key), d))

     svg.attr("id", 'goodlookingChart');
     svg.attr("height", chartHeight);

     svg.append("g")
     .attr("class", 'xaxis')
     .call(xAxis);

     svg.append("g")
     .attr("class", 'yaxis tier-axis no-tick')
     .call(yAxis);

     svg.append("g")
       .selectAll("g")
       .data(series)
       .join("g")
         .attr("fill", d => colorScale(d.key))
       .selectAll("rect")
       .data(d => d)
       .join("rect")
         .attr("x", d => xScale(d[0]))
         .attr("y", (d, i) => yScale(d.data.tier))
         .attr("width", d => xScale(d[1]) - xScale(d[0]))
         .attr("height", yScale.bandwidth())
         .on("mouseenter", function(e,d) {
            const x = xScale(d[0]) + (xScale(d[1]) - xScale(d[0])) / 2;
            const y = yScale(d.data.tier);

            let thisBar = d3.select(this);


            d3.select('#tooltip-goodlooking')
                        .transition()
                        .duration(200)
                        .style("display", "block");

            d3.select('#tooltip-goodlooking')
              .html(
                `<p> <b>${formatValue(d.data[d.key])}</b> ${d.key} villagers </p>`
              ).style(
                    "transform",
                    `translate(` + `calc( -50% + ${x}px),` + `calc(-100% + ${y}px)` + `)`
                  );

             d3.select(this).transition()
                    .duration(350)
                    .style("stroke", d => colorScale(d.key))

          })
          .on('mouseleave', function() {
            d3.select('#tooltip-goodlooking')
              .transition()
              .duration(200)
              .style("display", "none")

            d3.select(this)
              .transition()
              .style("stroke", 'none')
          })

   }

   drawDistributionChart2(){
     var svg = this.svg,
         chartWidth = this.svgRef.current.clientWidth,
         chartHeight = 430,
         stackKeys = colorWheelArray,
         //stackKeys = [1,1.5,2,2.5,3],
         radius = 40;

     svg.attr("id", 'goodlookingChart');
     svg.attr("height", chartHeight);

     //let allVillagers = this.allVillagers;

     let tierNodes2 = this.tierNodes2,
         tierArray = this.tierArray;

     let tableData = Array.from(tierNodes2.entries())
     .map(g => {
       const obj = {};
       obj["tier"] = g[0];
       for (let col of stackKeys) {
         const vals = g[1].get(col);
         //console.log("vals: "+vals);
         obj[col] = !vals ? 0 : vals;
       }
       return obj;
     })
    .sort((a, b) => a["tier"] - b["tier"]);


    const yMaxArray = stackKeys.map(score => {
      let max = d3.max(tableData, d => d[score])
      return max;
    });

     const yMax = d3.max(yMaxArray, d => d);

     const totalBarGroups = stackKeys.length;

     const xScale = d3.scaleBand()
                     .domain(tierArray)
                     .range([margin.left, chartWidth - margin.right])
                     //.padding(0.5)

     const yScale = d3.scaleLinear()
                     .domain([ 0, yMax ])
                     .range([ chartHeight/totalBarGroups - margin.top, margin.top/totalBarGroups])

     const xAxis = g => g
                 .attr("transform", `translate(0,${ chartHeight - margin.top/1.5})`)
                 .call(d3.axisBottom(xScale).tickFormat(function(d,i){ return `T.${d}` }).tickSizeOuter(0))
                 .call(g => g.selectAll(".domain").remove());

     const yAxis = g => g
               .call(d3.axisLeft(yScale).ticks(5).tickSizeOuter(0))
               .call(g => g.selectAll(".domain").remove());

     svg.append("g")
      .attr("class", 'xaxis tier-axis')
      .call(xAxis);

     stackKeys.forEach((score, index) => {

       svg.append("g")
       .attr("transform", `translate(${margin.left}, ${margin.top/totalBarGroups + index*(chartHeight/totalBarGroups)})`)
       .call(yAxis);

       svg.append("g")
         .attr('class', `bars-${scoreObj[score]}`)
         .selectAll('rect')
         .data(tableData)
         .join('rect')
           .attr('class', 'bar')
           .attr('x', d => xScale(d.tier))
           .attr('y', d => yScale(d[score]) + margin.top/totalBarGroups + index*(chartHeight/totalBarGroups))
           .attr('width', xScale.bandwidth())
           .attr('height', d => yScale(0) - yScale(d[score]))
           //.style('stroke', '#017C74')
           .style('fill', colorWheelObj[score])
           .style("opacity", 0.8)
           .append("title")
           .text(d => ` ${score} in Tier ${d.tier}, Total: ${d[score]}`);

      let barLabels = svg.append("g")
          .attr('class', `bar-label-${scoreObj[score]}`)
          .attr("transform", `translate(${chartWidth - margin.right/5}, ${margin.top/2 + index*(chartHeight/totalBarGroups)}) rotate(90)`)

      barLabels.append('rect')
            .attr('class', 'bar-label-container')
            .style('stroke', '#017C74')
            .style('fill', 'transparent')
            .attr("width", d => yScale(0) - yScale(yMax))
            .attr("height", d => margin.right/2)

      barLabels.append('text')
            .attr('class', 'bar-label')
            //.attr("transform", "rotate(90)")
            .style("font-size",8)
            //.style('fill', '#ffffff')
            .attr("x", d => margin.right/5)
            .attr('y', d => yScale(yMax))
            .attr("dy", ".35em")
            .text(function(d) { return `${score}` });

     });


   }



   drawDistributionChart(){
        var svg = this.svg,
            chartWidth = this.svgRef.current.clientWidth,
            chartHeight = 430,
            stackKeys = colorWheelArray,
            totalBarGroups = colorWheelArray.length,
            strokeColor = 'rgba(1,124,116,1)',
            fillColor = 'rgba(1,124,116,0.5)',
            fillColorLight = 'rgba(1,124,116,0.1)',
            noOfColumns = 1;

        svg.attr("id", 'goodlookingChart');
        svg.attr("height", chartHeight);


        let tierNodes2 = this.tierNodes2,
            tierArray = this.tierArray,
            noOfChartsPerCol = Math.round(totalBarGroups/noOfColumns);

        this.dataSet = Array.from(tierNodes2.entries())
         .map(g => {
           const obj = {};
           obj["tier"] = g[0];
           for (let col of stackKeys) {
             const vals = g[1].get(col);
             obj[col] = !vals ? 0 : vals;
           }
           return obj;
         })
        .sort((a, b) => a["tier"] - b["tier"]);


        let tableData = this.dataSet;

        const yMaxArray = stackKeys.map(appearancescore => {
          let max = d3.max(tableData, d => d[appearancescore])
          return max;
        });



         const yMax = d3.max(yMaxArray, d => d);


         const xScale = d3.scaleBand()
                         .domain(tierArray)
                         .range([margin.left, chartWidth/noOfColumns - margin.right])
                         //.padding(0.5)

         const yScale = d3.scaleLinear()
                         .domain([0, yMax ])
                         .range([chartHeight/noOfChartsPerCol - margin.top, margin.top/noOfChartsPerCol])

         const xAxis = g => g
                     .call(d3.axisBottom(xScale).ticks(5).tickSizeOuter(0)) //.tickFormat(function(d,i){ return `T.${d}` })
                     .call(g => g.selectAll(".domain").remove());

         const yAxis = g => g
                   .call(d3.axisLeft(yScale).ticks(2).tickSizeOuter(0))
                   .call(g => g.selectAll(".domain").remove());


         // Creating the clone of the array
         let clonetableData = tableData.slice(0);

         const clonetableDataArr = tableData.map(d => ({ ...d}));

         // Extract the array using splice method
         let tableDataExtended = clonetableDataArr.splice(0,tierArray.length);

         const clonetableDataFirst = tableDataExtended[0];
         const clonetableDataLast = tableDataExtended[tierArray.length-1];

         //let tableDataExtended = tableData.slice();

         tableDataExtended.unshift(clonetableDataFirst);
         tableDataExtended.push(clonetableDataLast);

         let newFirst = tableDataExtended[0],
             newLast = tableDataExtended[tableDataExtended.length-1];

         stackKeys.forEach((appearancescore, index) => {
           // define the area
           let area = d3.area()
               //.x(d => xScale(d.tier))
               .x((d,i) => {
                 if(i === 0){
                   return xScale.bandwidth()/2 + margin.left/2
                 }else if(i === (tableDataExtended.length-1)){
                   return xScale(d.tier) + xScale.bandwidth()/2
                 }else{
                   return xScale(d.tier)
                 }
               })
               .y0(yScale(0))
               .y1(d => yScale(d[appearancescore]))
               //.y1(d => d.tier === "Start" ? yScale(d[appearancescore]) : yScale(d[appearancescore]))
               .curve(d3.curveStep)

           // define the line
           let line = d3.line()
                     //.x(d => xScale(d.tier))
                     .y(d => yScale(d[appearancescore]))
                     .x((d,i) => {
                       if(i === 0){
                         return xScale.bandwidth()/2 + margin.left/2
                       }else if(i === (tableDataExtended.length-1)){
                         return xScale(d.tier) + xScale.bandwidth()/2
                       }else{
                         return xScale(d.tier)
                       }
                     })
                     //.y(d => d.tier === "Start" ? yScale(d[firstappearancescore]) : yScale(d[appearancescore]))
                     .curve(d3.curveStep)



          let group = svg.append("g")
            .attr('class', `path-${appearancescore}`);


          let barLabels = svg.append("g")
              .attr('class', `bar-label-${appearancescore}`)

          // Add the area
          group.append('path')
              .datum(tableDataExtended)
              .attr('class', `path-goodlooking`)
              .style('fill', fillColorLight)
              .attr("d",area)
         // Add the line
          group.append("path")
             .datum(tableDataExtended)
             .attr("fill", "none")
             .attr("stroke", strokeColor)
             .attr("stroke-width", 2)
             .attr("d", line)


             barLabels.append('circle')
             .attr('class', 'bar-label-container')
             .style('stroke', fillColorLight)
             .style("fill", `url(#villager-appearancescore-${appearancescore})`)
             .attr("r", d => yScale(yMax/1.25));

             barLabels.append('text')
                   .attr('class', 'bar-label')
                   //.attr("transform", "rotate(90)")
                   .style("font-size",7)
                   .style("text-anchor", "middle")
                   .attr("x", d => 0)
                   .attr('y', d => yScale(yMax/2))
                   .attr("dy", ".4em")
                   .text(function(d) { return `${appearancescore}` });


           // Add labels
         /*  barLabels.append('rect')
                 .attr('class', 'bar-label-container')
                 .style('stroke', '#017C74')
                 .style('fill', 'transparent')
                 .attr("width", d => yScale(0) - yScale(yMax))
                 .attr("height", d => margin.right/2)

           barLabels.append('text')
                 .attr('class', 'bar-label')
                 //.attr("transform", "rotate(90)")
                 .style("font-size",8)
                 //.style('fill', '#ffffff')
                 .attr("x", d => margin.right/5)
                 .attr('y', d => yScale(yMax))
                 .attr("dy", ".35em")
                 .text(function(d) { return `${appearancescore}` });
   */

           if(index < noOfChartsPerCol){
             svg.append("g")
             .attr("transform", `translate(${0}, ${chartHeight - margin.top/2})`)
             .attr("class", 'xaxis tier-axis')
             .call(xAxis);

             svg.append("g")
             .attr("transform", `translate(${margin.left}, ${margin.top/noOfColumns + index*(chartHeight/noOfChartsPerCol) - margin.top/2})`)
             .attr("class", 'yaxis')
             .call(yAxis);

             group.attr("transform", `translate(${0  + margin.right/4}, ${margin.top/2 + index*(chartHeight/noOfChartsPerCol)})`)

             barLabels.attr("transform", `translate(${chartWidth/noOfColumns - margin.right/2.25}, ${margin.top/1.125 + index*(chartHeight/noOfChartsPerCol)}) rotate(0)`)

           }else{
             svg.append("g")
             .attr("transform", `translate(${chartWidth/noOfColumns}, ${chartHeight - margin.top/2})`)
             .attr("class", 'xaxis tier-axis')
             .call(xAxis);

            svg.append("g")
             .attr("transform", `translate(${chartWidth/noOfColumns + margin.left}, ${margin.top/noOfColumns + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)})`)
             .attr("class", 'yaxis')
             .call(yAxis);

             group.attr("transform", `translate(${chartWidth/noOfColumns + margin.right/4}, ${margin.top/2 + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)})`)

             barLabels.attr("transform", `translate(${chartWidth - margin.right/2.25}, ${margin.top/1.125 + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)}) rotate(0)`)

           }



         });


    }


   removeChart(){
     d3.selectAll("#goodlookingChart > *").remove();
   }

   changeChart(chartType){
     let newChartType;
     this.removeChart()
     if(chartType === "viewbyPercentage"){
         newChartType = "viewbyPercentage"
         this.drawStackBarChart()
     }else if(chartType === "viewbyDistribution"){
         newChartType = "viewbyDistribution"
         this.drawDistributionChart()
     }

     this.setState({
       chartType : newChartType
     })
   }


  render() {
    //chart toggle
    const btnList = [
        {
            id: 1,
            label: '% Stack Chart',
            functionParams: "viewbyPercentage",
            isSelected: true,
        },
        {
            id: 2,
            label: 'Distribution',
            functionParams: "viewbyDistribution",
            isSelected: false,
        },
    ];

    return (
      <div ref={this.props.innerRef}  id={`villager-${this.props.step}`} className="step category-appearance">
          <h2 className="title">Subjective looks</h2>
          <p className="paragraph">As much as we’d like to pretend looks don’t matter, we do have to acknowledge that some villagers are inherently cuter, whereas some look a bit stranger. Everyone’s definition of good-looking is different, and we didn’t have a “definitive” measure of a villager’s attractiveness, so we decided to use our own personal judgment to quantify each villager’s appearance.</p>
          <p className="paragraph"><span className="medium">Based on our personal preferences, are the good-looking villagers more popular?</span></p>
          <p className="paragraph">Both of us assigned an appearance score to each villager, ranging from <span className="unique-square dark">very good looking</span> ~ <span className="unique-square light">very strange looking</span>, and we averaged the scores between the two of us to obtain a final appearance score:</p>
          <ul className={`chart-key-list long-list`}>
            {colorWheelArray.map(list => {
                return (
                  <li key={list}><span style={{backgroundColor: colorWheelObj[list]}}></span>{list.replace(/Looking/g, "")}</li>
                )
            })}
          </ul>
          <div className="svg-wrapper">
            <div id="tooltip-goodlooking" className="bar-tooltip"></div>
            <svg ref={this.svgRef} width="100%"></svg>
          </div>
          <p className="paragraph">
          From the charts above, it is clear that the villagers we considered good looking tended to occupy the top popularity tiers, while the villagers we considered strange looking tended to occupy the lower popularity tiers.
          </p>
          <p className="paragraph haspointer"> In fact, all of the top 40 villagers had an appearance score of <span className="medium">Average</span>, <span className="medium">Good Looking</span>, or <span className="medium">Very Good Looking</span>. Only 1 <span className="medium">Very Good Looking</span> villager,  <VillagerAvatar villagers={this.allVillagers} villager="Chai"/>, ranks below 300 from the popularity vote, and that is because she is a newer Sanrio character.</p>
          <Dialogue title="Summary" type="regular">
            <p className="paragraph">Assuming everyone’s preferences are similar to ours, a villager’s popularity seems very closely related to how good they look!</p>
          </Dialogue>
      </div>
    )
  }
}

export default VillagerAppearanceGoodlooking;
